// extracted by mini-css-extract-plugin
export var bannerContainer = "HealthyMetabolism-module--bannerContainer--6aMyw";
export var bannerImage = "HealthyMetabolism-module--bannerImage--UOdGW";
export var card = "HealthyMetabolism-module--card--z8aUz";
export var cardContent = "HealthyMetabolism-module--cardContent--kOiIS";
export var cardIcon = "HealthyMetabolism-module--cardIcon--T6S0v";
export var cardsGrid = "HealthyMetabolism-module--cardsGrid--fkXLY";
export var contentSection = "HealthyMetabolism-module--contentSection--Z0BbU";
export var description = "HealthyMetabolism-module--description--rpPAf";
export var headerSection = "HealthyMetabolism-module--headerSection--sZqvi";
export var healthyMetabolismWrapper = "HealthyMetabolism-module--healthyMetabolismWrapper--viEc3";
export var iconWrapper = "HealthyMetabolism-module--iconWrapper--fMVDu";
export var mainDescription = "HealthyMetabolism-module--mainDescription--JLwcK";
export var mainTitle = "HealthyMetabolism-module--mainTitle--nGvik";
export var percentage = "HealthyMetabolism-module--percentage--QAdD3";
export var textWrapper = "HealthyMetabolism-module--textWrapper--c1mjy";